module.exports = __webpack_public_path__ + "static/shyamala1.b7f5aea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shyamala1.jpg
// module id = 934
// module chunks = 118785002076118